export enum BuilderArea {
  data = 'data',
  settings = 'settings',
  layout = 'layout',
  preview = 'preview',
  filters = 'filters',
}

export enum DataPointModel {
  dataFusion,
  dataPoint,
}